import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav data-testid="navbar" className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-b border-border/40">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-20">
          <Link
            to="/"
            data-testid="brand-wordmark"
            className="font-heading text-xl md:text-2xl font-semibold text-primary tracking-[0.15em] hover:text-accent transition-colors"
          >
            LANTERN PREP
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/about" className="text-foreground hover:text-accent transition-colors font-medium text-sm">
              About
            </Link>
            <Link to="/scholarship-model" className="text-foreground hover:text-accent transition-colors font-medium text-sm">
              Scholarship Model
            </Link>
            <Link to="/how-it-works" className="text-foreground hover:text-accent transition-colors font-medium text-sm">
              How It Works
            </Link>
            <Link to="/programs" className="text-foreground hover:text-accent transition-colors font-medium text-sm">
              Programs
            </Link>
            <Link 
              to="/contact" 
              className="bg-accent text-accent-foreground px-6 py-2.5 rounded-sm font-medium text-sm hover:bg-accent/90 transition-all"
            >
              Request Consultation
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-button"
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-foreground hover:text-accent transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div data-testid="mobile-menu" className="md:hidden py-4 border-t border-border/40">
            <div className="flex flex-col space-y-4">
              <Link
                to="/about"
                onClick={() => setIsOpen(false)}
                className="text-foreground hover:text-accent transition-colors font-medium py-2 text-sm"
              >
                About
              </Link>
              <Link
                to="/scholarship-model"
                onClick={() => setIsOpen(false)}
                className="text-foreground hover:text-accent transition-colors font-medium py-2 text-sm"
              >
                Scholarship Model
              </Link>
              <Link
                to="/how-it-works"
                onClick={() => setIsOpen(false)}
                className="text-foreground hover:text-accent transition-colors font-medium py-2 text-sm"
              >
                How It Works
              </Link>
              <Link
                to="/programs"
                onClick={() => setIsOpen(false)}
                className="text-foreground hover:text-accent transition-colors font-medium py-2 text-sm"
              >
                Programs
              </Link>
              <Link
                to="/contact"
                onClick={() => setIsOpen(false)}
                className="bg-accent text-accent-foreground px-6 py-2.5 rounded-sm font-medium text-sm text-center"
              >
                Request Consultation
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
